import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#C40000"
}
function SkiMak027({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M15.95 0Q13.1 2.6 11.5 5.7 6.9 15.9 10.35 36q.1.55.2 1.15 3.55 14.5 2.65 29.05 0 .85-.05 1.45-.35 4.6-1.25 9.05-.4 1.2-1.2 2.8h-.05q-.7 1.65-1.2 2.35-1.1 1.35-4.35 4.5-4.65 3.5-5.05 8.2 0 .3-.05.6-.05.55.05 1.15.5 4.4 7.95 8.05 5.3 2.2 9.95 2.5v-.05l-1.5-.5q-7.25-2.5-10.35-6.2l-.8-1.05q-1.15-1.8-1.1-3.75v-.45q.45-3.25 3.7-5.7.1-.1.2-.15 3.5-3.5 4.8-5h.05q.65-.95 1.65-3.05V81q1-2 1.45-3.5.05-.1.05-.15.9-4.65 1.3-9.4.05-.7.05-1.75 1.2-14.7-2.6-29.05-.6-3-1.3-6.9-.55-2.55-.6-6.95l-.05-.3Q12.25 8.5 16 0h-.05M86.1 86.35q-3.2-3.15-4.35-4.5-.45-.7-1.2-2.35h-.05q-.8-1.6-1.15-2.8-.9-4.45-1.3-9.05-.05-.6-.05-1.45-.9-14.55 2.65-29.05.1-.6.2-1.15Q84.3 15.9 79.7 5.7 78.1 2.6 75.25 0h-.05q3.75 8.5 3.15 23l-.1.3q-.05 4.4-.55 6.95-.75 3.9-1.35 6.9-3.8 14.35-2.55 29.05 0 1.05.05 1.75.35 4.75 1.25 9.4 0 .05.05.15.5 1.5 1.5 3.5v-.05q1 2.1 1.6 3.05h.1q1.25 1.5 4.8 5l.15.15q3.3 2.45 3.7 5.7v.45q.05 1.95-1.1 3.75l-.3.4-.45.65q-3.1 3.7-10.35 6.2l-1.5.5q-.05 0-.05.05 4.65-.3 9.95-2.5 7.45-3.65 8-8.05.1-.6.05-1.15-.05-.3-.05-.6-.45-4.7-5.1-8.2z"
                    id="SkiMak027__Symbol_34_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiMak027__Symbol_34_0_Layer0_0_FILL"
                transform="translate(146.9 112.35)"
                id="SkiMak027__col1n"
            />
        </g></g>
    )
}
export default SkiMak027
